<template>
  <div class="auth-layout">
    <!-- <div class="nav d-lg-none">
      <router-link :to="{path: '/'}">
        <vuestic-icon-vuestic/>
      </router-link>
    </div> -->
    <div class="main va-row">
      <div class="flex lg6 xs12 fill-height" :class="{ 'auth-content': isLargeScreen, 'auth-content-app': !isLargeScreen }" :style="isLargeScreen?'':`height:100%;background-image:url(${rightBgH5});`">
        <div class="flex-center">
          <router-view/>
        </div>
      </div>
      <!-- <div class="auth-content flex lg6 xs12 fill-height">
        <div class="flex-center">
          <router-view/>
        </div>
      </div>
      <div class="auth-content-app flex lg6 xs12 fill-height" :style="`height:100%;background-image:url(${rightBgH5});`">
        <div class="flex-center">
          <router-view/>
        </div>
      </div> -->
      <div class="auth-layout__auth-wallpaper flex md6 auth-layout__auth-container" :style="`height:100%;background-image:url(${rightBgPc});`"></div>
        <!-- <div class="flex-center">
          <div class="auth-layout__auth-wallpaper__cross-line"/>
          <router-link class="auth-layout__auth-wallpaper__logo" :to="{path: '/'}">
            <vuestic-icon-vuestic/>
          </router-link>
        </div> -->
    </div>
  </div>
</template>

<script>
// d-none and d-lg-flex were deleted, bug will be fixed in the nearest update
import VuesticIconVuestic
  from '../../vuestic-theme/vuestic-components/vuestic-icon/VuesticIconVuestic'

export default {
  name: 'AuthLayout',
  data() {
    return {
      clientWidth: ''
    }
  },
  created() {
    this.clientWidth = document.documentElement.clientWidth
  },
  mounted() {
    const _this = this;
    window.onresize = () => {
      return (() => {
        // console.log('_this.clientWidth->', _this.clientWidth)
        _this.clientWidth = `${document.documentElement.clientWidth}`
      })()
    }
  },
  computed: {
    isLargeScreen () {
      return this.clientWidth >= 1027
    },
    rightBgH5() { // 'HK',
      const countryArray = ['AR', 'AT', 'AU', 'BR', 'CH', 'CL', 'CN', 'CO', 'DE', 'DN', 'EG', 'FL', 'FR', 'ID', 'IN', 'IT', 'KH', 'KO', 'KW', 'LX', 'MX', 'MY', 'NL', 'NW', 'PE', 'PL', 'PT', 'PY', 'SA', 'SG', 'SP', 'SW', 'TH', 'TR', 'UK', 'US', 'VT']
      const randomNumber = Math.floor(Math.random() * 37)
      return require(`@/assets/images/login/country/h5/${countryArray[randomNumber]}.webp`)
    },
    rightBgPc() {
      const countryArray = ['AR', 'AT', 'AU', 'BR', 'CH', 'CL', 'CN', 'CO', 'DE', 'DN', 'EG', 'ES', 'FL', 'FR', 'ID', 'IN', 'IT', 'KH', 'KO', 'KW', 'LX', 'MX', 'MY', 'NL', 'NW', 'PE', 'PL', 'PT', 'PY', 'SA', 'SG', 'SW', 'TH', 'TR', 'UK', 'US', 'VT']
      const randomNumber = Math.floor(Math.random() * 37)
      return require(`@/assets/images/login/country/pc/${countryArray[randomNumber]}.webp`)
    }
  },
  components: { VuesticIconVuestic },
}
</script>

<style lang="scss">
.auth-layout {
  height: 100vh;
  margin: 0;

  &__auth-wallpaper {
    position: relative;
    background-color: $top-nav-bg;
    overflow: hidden;
    @include va-flex-center();
    &__logo {
      z-index: 2;
      position: absolute;
      height: $auth-wallpaper-ivuestic-h;
      width: 100%;
    }
    .vuestic-icon-vuestic {
      height: $auth-wallpaper-ivuestic-h;
      width: 100%;
    }

    &__cross-line {
      z-index: 1;
      position: absolute;
      background-color: $auth-wallpaper-oblique-line;
      left: calc(50% - 27% / 2);
      transform: rotate(15deg);
      width: 27%;
      height: 115%;
    }
  }

  .nav {
    display: flex;
    align-items: center;
    justify-content: center;
    height: $top-mobile-nav-height;
    background-color: $top-nav-bg;
    .vuestic-icon-vuestic {
      height: $auth-mobile-nav-ivuestic-h;
      width: 100%;
    }
  }
  .main {
    margin: 0;
    height: 100vh;
    .auth-content {
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: white;
    }
    .auth-content-app {
      display: none;
    }
  }

  /* @include media-breakpoint-down(md) { */
  @media screen and (max-width: 1026px) {
    .main {
      /* height: $auth-mobile-main-h; */
      height: 100vh;
      .auth-content {
        display: none;
        align-items: flex-start;
        padding-top: $auth-content-padding-t;
      }
      .auth-content-app {
        padding: 0 18px;
        display: flex;
        background-size: cover;
        // 重写 lg6 992 改为 1024
        -ms-flex-preferred-size: 100%;
        flex-basis: 100%;
        -webkit-box-flex: 0;
        -ms-flex-positive: 0;
        flex-grow: 0;
        max-width: 100%;
      }
      .auth-wallpaper {
        display: none;
      }
    }
  }
  @media screen and (max-width: 429px) {
    .main {
      .auth-content-app {
        padding: 0 16px;
      }
    }
  }
}
.auth-layout__auth-container {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  display: block;
  /* @include media-breakpoint-down(md) { */
  @media screen and (max-width: 1026px) {
    display: none;
  }
}
</style>
